import {
  FETCH_MASTER_DATA_LIST,
  RESET_MASTER_DATA_LIST,
} from "../../constants/action.constants";

const initialState = {
  list: [],
  others: {
    total: 0,
    offset: 0,
    limit: 20,
  },
};

const masterDataList = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_MASTER_DATA_LIST:
      return { list: action.payload, others: action.others };
    case RESET_MASTER_DATA_LIST:
      return initialState;
    default:
      return state;
  }
};

export default masterDataList;
